import { useTimeFormat } from 'contexts/TimeFormatContext'
import DateTimePickerCustom from '../../DatePicker/DateTimePickerCustom'
import moment from 'moment'
import objectPath from 'object-path'
import { useMemo } from 'react'
import CalendarTimePickerCustom from '../../DatePicker/CalendarTimePickerCustom'
import { checkLockMode } from '../action/Column'

const CustomDateTime = ({
  id,
  name,
  ui,
  rowData,
  onUpdateRowData,
  error,
  column,
  handleKeyDown,
  isTable
}) => {
  let { dateFormat, timeFormat } = useTimeFormat()
  let formatTypeDate = objectPath.get(ui, 'date.formatType')
  let formatTypeTime = objectPath.get(ui, 'time.formatType')
  let customFormatDate = objectPath.get(ui, 'date.format')
  let customFormatTime = objectPath.get(ui, 'time.format')
  let ampm = objectPath.get(ui, 'time.ampm')
  let year = objectPath.get(ui, 'date.year')
  let calendar = year === 543 ? 'BE' : 'BC'
  let value = objectPath.get(rowData, ui.field)
  let dateTime = value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : null
  let isLockEdit = checkLockMode(column, rowData)
  const formatDate = useMemo(() => {
    if (formatTypeDate === 'custom') {
      return customFormatDate
    }
    return dateFormat
  }, [formatTypeDate, customFormatDate, year])

  const formatTime = useMemo(() => {
    if (formatTypeTime === 'custom') {
      return customFormatTime
    }
    return timeFormat
  }, [formatTypeTime, customFormatTime, ampm])

  const updateData = (dateTime) => {
    let value = null
    if (dateTime?.value) {
      value = moment(dateTime.value).format('YYYY-MM-DD HH:mm:ss')
    }
    objectPath.set(rowData, ui.field, value)
    onUpdateRowData(rowData)
  }

  return (
    <>
      <CalendarTimePickerCustom
        readonly={isLockEdit}
        ui={ui}
        id={id}
        name={name}
        formatDisplay={`${formatDate ?? 'DD/MM/YYYY'} ${formatTime ?? 'HH:mm'}`}
        dateFormat={formatDate ?? 'DD/MM/YYYY'}
        timeFormat={formatTime ?? 'HH:mm'}
        placeholder={`${formatDate} ${formatTime}`}
        value={dateTime}
        onChange={updateData}
        isClearable={true}
        calendar={calendar}
        ampm={ampm}
        error={error}
        style={error ? { borderColor: 'red' } : {}}
        handleKeyDown={(e) => handleKeyDown(e, rowData)}
        onUpdateRowData={onUpdateRowData}
        isTable={isTable}
      />
    </>
  )
}

export default CustomDateTime
